import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface CreateSubjectiveParams {
  patientId: string;
  encounterId: string;
}

interface CreateSubjectiveResponse {
  documentReferences: fhirTypes.DocumentReference[];
}

export const useCreateSubjective = ({
  encounterId,
  patientId,
}: { encounterId?: string; patientId?: string }) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateSubjectiveResponse, CreateSubjectiveParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Subjective.CREATE(
        patientId,
        encounterId,
      ),
      mutationFn: (params) => {
        return axiosInstance.post("/charting/subjective/", params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Subjective.DEFAULT({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId: encounterId,
          }),
        });
      },
    },
  });
};
